(() => {
  const SELECTOR = '[data-kh-ogf]';

  const ready = (root) => {
    if (!root || root.dataset.khOgfReady === 'true') return;
    root.dataset.khOgfReady = 'true';

    const scroller = root.querySelector('[data-kh-ogf-scroller]');
    const prev = root.querySelector('[data-kh-ogf-prev]');
    const next = root.querySelector('[data-kh-ogf-next]');
    const progress = root.querySelector('[data-kh-ogf-progress]');
    const thumb = root.querySelector('[data-kh-ogf-thumb]');
    if (!scroller) return;

    const card = scroller.querySelector('.kh-ogf__card');
    const step = () => {
      const gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap) || 16;
      return (card ? card.getBoundingClientRect().width : scroller.clientWidth * 0.7) + gap;
    };

    const sync = () => {
      const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      if (prev) prev.disabled = scroller.scrollLeft <= 2;
      if (next) next.disabled = scroller.scrollLeft >= max - 2;

      if (progress && thumb) {
        if (max < 8) {
          progress.hidden = true;
          return;
        }
        progress.hidden = false;
        const total = scroller.scrollWidth;
        thumb.style.width = `${(scroller.clientWidth / total) * 100}%`;
        thumb.style.marginLeft = `${(scroller.scrollLeft / total) * 100}%`;
      }
    };

    prev?.addEventListener('click', () => {
      scroller.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      scroller.scrollBy({ left: step(), behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    requestAnimationFrame(sync);
  };

  const boot = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(ready);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
